import React from 'react';
import { Box } from '@mui/material';
import type { ScopeOption } from '@hopdrive/feature-global-search';
import CustomerSelect from '@features/customers/components/CustomerSelect';

interface RooftopFilterProps {
  /**
   * The rooftops in scope, per the feature's slot contract. Admin ignores them:
   * the house CustomerSelect fetches the full active-customer list itself, and
   * an admin can filter to any rooftop. The feature passes them so a portal
   * whose picker is fed from app state (the dealer's) can use the same slot.
   */
  options?: ScopeOption[];
  value?: number | null;
  onChange: (customerId?: number) => void;
}

/**
 * Rooftop filter for the search results page — the house customer picker
 * (single-select), sized to sit in the shared filter row's extraControls slot.
 * Narrows every section to the picked rooftop; clearing returns to all.
 */
const RooftopFilter: React.FC<RooftopFilterProps> = ({ value, onChange }) => (
  <Box sx={{ width: 240 }}>
    <CustomerSelect
      multiple={false}
      label='Rooftop'
      selectedCustomerIds={value != null ? [value] : []}
      onChange={ids => onChange(ids[0])}
    />
  </Box>
);

export default RooftopFilter;
